import React from 'react';
import { createRoot } from 'react-dom/client';
import ContentModule from './components/ContentModule';
import KnipsModule from './components/KnipsModule';
import {
  ContentModuleDataProvider,
  KnipsDataProvider,
  getContentModuleDataContext,
  getKnipsDataContext,
} from './helpers/DataContext';

const knipsEl = document.getElementById('content-realestate-knips-module');
const contentModuleEl = document.getElementById('content-realestate-content-module');

if (knipsEl) {
  const root = createRoot(knipsEl);
  const data = getKnipsDataContext('knips-module-data');

  root.render(
    <KnipsDataProvider value={data}>
      <KnipsModule />
    </KnipsDataProvider>
  );
}

if (contentModuleEl) {
  const root = createRoot(contentModuleEl);
  const data = getContentModuleDataContext('content-module-data');
  root.render(
    <ContentModuleDataProvider value={data}>
      <ContentModule />
    </ContentModuleDataProvider>
  );
}
